module.exports = __webpack_public_path__ + "static/img/USDT.eabedbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/USDT.png
// module id = UzWH
// module chunks = 2